module.exports = __webpack_public_path__ + "img/fa571486-14a9-4f24-8e9c-31dc08e3f3f7.72040c98.jpg";